
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { t, setLanguage, getLanguage } from '../i18n';

// Utility to get API base URL depending on environment
const getApiBaseUrl = () => {
  if (
    window.location.hostname === 'localhost' ||
    window.location.hostname === '127.0.0.1'
  ) {
    return 'http://localhost:3000';
  }
  // Always use the production backend for any other hostname
  // Use relative URL for production
  return '';
};

const LoginPage = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      const response = await fetch(`${getApiBaseUrl()}/api/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.error || 'Erreur lors de la connexion');
      }

      const data = await response.json();
      localStorage.setItem('token', data.token); // Save the token
      navigate('/mon-compte'); // Redirect to UserPage
    } catch (err) {
      console.error('Login error:', err);
      alert('Nom d\'utilisateur ou mot de passe invalide');
    }
  };



  return (
    <div style={styles.page}>
      <h1 style={styles.title}>{t('loginTitle') || 'Connexion'}</h1>
      <form onSubmit={handleLogin} style={styles.form}>
        <div style={styles.formGroup}>
          <label htmlFor="username" style={styles.label}>{t('usernameLabel') || "Nom d'utilisateur"}</label>
          <input
            type="text"
            id="username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            style={styles.input}
          />
        </div>
        <div style={styles.formGroup}>
          <label htmlFor="password" style={styles.label}>{t('passwordLabel') || 'Mot de passe'}</label>
          <input
            type="password"
            id="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            style={styles.input}
          />
        </div>
        <button type="submit" style={styles.button}>{t('loginButton') || 'Se connecter'}</button>
      </form>
      <p style={styles.text}>
        {t('noAccount') || 'Pas encore de compte ?'}{' '}
        <span
          onClick={() => navigate('/create-user')}
          style={styles.link}
        >
          {t('createAccount') || 'Créer un compte'}
        </span>
      </p>
      {/* Language switcher removed; use FooterBar for language selection */}
    </div>
  );
};

const styles = {
  page: {
    textAlign: 'center',
    padding: '20px',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: '20px',
    justifyContent: 'center',
  },
  title: { fontSize: '24px', fontWeight: 'bold', marginBottom: '20px' },
  form: { maxWidth: '400px', width: '100%' },
  formGroup: { marginBottom: '15px' },
  label: { display: 'block', marginBottom: '5px', fontWeight: 'bold' },
  input: {
    width: '100%',
    padding: '10px',
    fontSize: '16px',
    borderRadius: '5px',
    border: '1px solid #ccc',
  },
  button: {
    padding: '10px 20px',
    fontSize: '16px',
    backgroundColor: 'var(--green-eucalyptus)',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
  },
  text: { marginTop: '20px', fontSize: '14px' },
  link: {
    color: 'var(--blue)',
    textDecoration: 'underline',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: 'bold',
  },
};

export default LoginPage;